import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Menu, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './styles';

const useStyles = makeStyles(styles);

const PaymentsListItemActionsMenu = ({
  anchorEl,
  onClose,
  paymentId,
  state,
  invoiceUrl,
  onShowDetail,
  onGoToInvoice,
  onCancel,
}) => {
  const classes = useStyles();

  const { t } = useTranslation('common');

  const isPending = useMemo(() => state === 'pending', [state]);

  const handleShowDetail = useCallback(() => {
    onShowDetail?.();
    onClose();
  }, [onClose, onShowDetail]);

  const handleGoToInvoice = useCallback(() => {
    const currentNewTab = window.open(invoiceUrl, '_blank', 'noreferrer');
    onGoToInvoice?.(currentNewTab);
    onClose();
  }, [invoiceUrl, onGoToInvoice, onClose]);

  const handleCancel = useCallback(() => {
    onCancel?.(paymentId);
    onClose();
  }, [onClose, onCancel, paymentId]);

  return (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id="payments-list-item-actions-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      classes={{
        paper: classes.listItemActionMenuPaper,
        list: classes.listItemActionMenuList,
      }}
    >
      <MenuItem
        className={classes.listItemActionMenuItem}
        onClick={handleShowDetail}
      >
        {t('payments.actionMenu.showDetail')}
      </MenuItem>

      {isPending && invoiceUrl && (
        <MenuItem
          className={classes.listItemActionMenuItem}
          onClick={handleGoToInvoice}
        >
          {t('payments.actionMenu.goToInvoice')}
        </MenuItem>
      )}

      {isPending && (
        <MenuItem
          className={cn(
            classes.listItemActionMenuItem,
            classes.listItemActionMenuItemError,
          )}
          onClick={handleCancel}
        >
          {t('payments.actionMenu.cancel')}
        </MenuItem>
      )}
    </Menu>
  );
};

PaymentsListItemActionsMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  paymentId: PropTypes.number.isRequired,
  state: PropTypes.string.isRequired,
  invoiceUrl: PropTypes.string,
  onShowDetail: PropTypes.func,
  onGoToInvoice: PropTypes.func,
  onCancel: PropTypes.func,
};

PaymentsListItemActionsMenu.defaultProps = {
  anchorEl: null,
  invoiceUrl: null,
  onShowDetail: null,
  onGoToInvoice: null,
  onCancel: null,
};

export default PaymentsListItemActionsMenu;
